const SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
const DIACRITICS = /[\u0300-\u036f]/g;

/** Converte um título em slug URL-safe (sem acento, kebab-case). */
export const slugify = (title: string): string =>
  title
    .normalize("NFD")
    .replace(DIACRITICS, "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/[\s-]+/g, "-")
    .replace(/^-+|-+$/g, "");

/** Valida se a string é um slug bem formado (kebab-case, sem extremidades soltas). */
export const validateSlug = (slug: string): boolean => SLUG_PATTERN.test(slug);

/**
 * Endereço curto a partir do título: o checklist de publicação exige no
 * máximo 60 caracteres, e o título de post (sobretudo gerado por IA) passa
 * disso com facilidade — o post do chatbot foi ao ar com 82. Corta na última
 * fronteira de palavra antes do limite, nunca no meio de uma palavra.
 */
export const SLUG_MAX_LENGTH = 60;

export const slugifyShort = (title: string, max: number = SLUG_MAX_LENGTH): string => {
  const full = slugify(title);
  if (full.length <= max) return full;
  const cut = full.slice(0, max + 1);
  const lastHyphen = cut.lastIndexOf("-");
  return (lastHyphen > 0 ? cut.slice(0, lastHyphen) : full.slice(0, max)).replace(/-+$/, "");
};
